import { useEffect, useState } from 'react'
import { breakpoints } from 'src/componentv2/Base/ui'

export type Breakpoint = 'desktop' | 'laptop' | 'tablet' | 'mobile'

const getBreakpoint = (width: number): Breakpoint => {
    if (width <= breakpoints.mobile) return 'mobile'
    if (width <= breakpoints.tablet) return 'tablet'
    if (width <= breakpoints.laptop) return 'laptop'
    return 'desktop'
}

/** Current responsive breakpoint, updated live as the viewport is resized. */
export const useBreakpoint = (): Breakpoint => {
    const [breakpoint, setBreakpoint] = useState<Breakpoint>(
        () => getBreakpoint(typeof window === 'undefined' ? Infinity : window.innerWidth),
    )

    useEffect(() => {
        const onResize = () => setBreakpoint(getBreakpoint(window.innerWidth))
        window.addEventListener('resize', onResize)
        onResize()
        return () => window.removeEventListener('resize', onResize)
    }, [])

    return breakpoint
}
